import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  domainList: [],
}

export const getters = {}

export const mutations = {
  CACHE_DOMAIN_LIST(state, newList) {
    state.domainList = newList
  },
}

export const actions = {
  fetchDomainList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/category?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_DOMAIN_LIST', list)
        return list
      })
  },
  addDomain({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/category`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  updateDomain({ commit, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/category/${Data.id}`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  deleteDomain({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/category/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  fetchSubDomainList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/subcategory?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_DOMAIN_LIST', list)
        return list
      })
  },
  addSubDomain({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/subcategory`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  updateSubDomain({ commit, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/subcategory/${Data.id}`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  deleteSubDomain({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/subcategory/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
}
